import { render } from "./ReactivationModal.vue?vue&type=template&id=45152fc4"
import script from "./ReactivationModal.vue?vue&type=script&lang=js"
export * from "./ReactivationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__